/* Octa Pearl product page logic (lg-product-main). */
(function () {
  'use strict';

  function money(cents, fmt) {
    var v = (cents / 100);
    var withDec = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var noDec = Math.round(v).toLocaleString('en-US');
    return String(fmt || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.'))
      .replace(/\{\{\s*amount\s*\}\}/, withDec)
      .replace(/<[^>]*>/g, '');
  }

  /* colour of a photo: alt text first ("... Yellow Gold"), then the colour code in the file name (-Y1, _Y_2, -YG, -11-Y) */
  function toneOf(src, alt) {
    var a = (alt || '').toLowerCase();
    if (/yellow gold/.test(a)) return 'yellow';
    if (/white gold|platinum/.test(a)) return 'white';
    if (/rose gold/.test(a)) return 'rose';
    var f = (src || '').split('?')[0].split('/').pop().toLowerCase().replace(/\.[a-z0-9]+$/, '');
    var t = f.split(/[-_]/).reverse();
    for (var i = 0; i < t.length; i++) { var m = t[i].match(/^([ywr])g?\d*$/); if (m) return { y: 'yellow', w: 'white', r: 'rose' }[m[1]]; }
    return null;
  }
  function toneOfValue(v) {
    v = (v || '').toLowerCase();
    if (v.indexOf('rose') > -1) return 'rose';
    if (v.indexOf('yellow') > -1) return 'yellow';
    if (v.indexOf('white') > -1 || v.indexOf('platinum') > -1) return 'white';
    return null;
  }

  /* "10K GOLD" -> "10K Gold", "WHITE" -> "White" */
  function nice(v) {
    return String(v || '').toLowerCase().replace(/(^|\s)(\S)/g, function (m, s, c) { return s + c.toUpperCase(); }).replace(/(\d+)k\b/g, '$1K');
  }

  function addBusinessDays(d, n) {
    var x = new Date(d.getTime());
    while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; }
    return x;
  }

  function init(root) {
    if (root.dataset.lgpReady) return;
    root.dataset.lgpReady = '1';
    var data = JSON.parse(root.querySelector('[data-lgp-json]').textContent);
    var product = data.product, fmt = data.moneyFormat;
    var form = root.querySelector('form[action*="/cart/add"]');
    form.setAttribute('novalidate', '');
    var idInput = form.querySelector('[data-lgp-id]');
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-lgp-opt]'));
    var nowEl = root.querySelector('[data-lgp-now]'), wasEl = root.querySelector('[data-lgp-was]');
    var atc = root.querySelector('[data-lgp-atc]'), atcLabel = root.querySelector('[data-lgp-atc-label]');
    var bar = root.querySelector('[data-lgp-bar]'), barPrice = root.querySelector('[data-lgp-bar-price]'), barBtn = root.querySelector('[data-lgp-bar-btn]');
    var size = root.querySelector('[data-lgp-ringsize]'), sizeWrap = root.querySelector('[data-lgp-size]'), err = root.querySelector('[data-lgp-err]');
    var dyn = root.querySelector('[data-lgp-dyn]'), msg = root.querySelector('[data-lgp-msg]');
    var metalCell = root.querySelector('[data-lgp-metal]'), skuCell = root.querySelector('[data-lgp-sku]');
    var current = null;
    var toneBox = root.querySelector('[data-lgp-tone]');
    var toneRadios = toneBox ? Array.prototype.slice.call(toneBox.querySelectorAll('input[data-tone]')) : [];
    var toneChosen = toneBox ? toneBox.querySelector('[data-lgp-tone-chosen]') : null;
    var toneNote = toneBox ? toneBox.querySelector('[data-lgp-tone-note]') : null;
    function toneLabel(r) { return r ? r.value : ''; }
    root.querySelectorAll('.lgp__pill, .lgp__swname').forEach(function (el) { el.textContent = nice(el.textContent.trim()); });
    /* one-value rows: keep Metal / Metal color visible (they tell the buyer what they get), hide others like Stone */
    root.querySelectorAll('.lgp__opt.is-single').forEach(function (o) {
      var l = (o.querySelector('legend') || {}).textContent || '';
      if (/^\s*metal/i.test(l)) o.classList.remove('is-single');
    });
    /* phones: start with the long description closed */
    if (window.matchMedia('(max-width: 989px)').matches) root.querySelectorAll('.lgp__acc details[open]:not([data-lgp-desc-acc])').forEach(function (d) { d.open = false; });

    /* ---------- description: first 5 lines, then "Read more" ---------- */
    var desc = root.querySelector('[data-lgp-desc]');
    if (desc) {
      var body = desc.querySelector('.lgp__rte'), more = desc.querySelector('[data-lgp-more]');
      var clampDesc = function () {
        if (desc.classList.contains('is-open')) return;
        desc.classList.add('is-clamped');
        var tooLong = body.scrollHeight > body.clientHeight + 8;
        desc.classList.toggle('is-clamped', tooLong);
        more.hidden = !tooLong;
      };
      more.addEventListener('click', function () {
        var open = !desc.classList.contains('is-open');
        desc.classList.toggle('is-open', open);
        desc.classList.toggle('is-clamped', !open);
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? 'Read less' : 'Read more';
        if (!open) desc.scrollIntoView({ block: 'nearest' });
      });
      clampDesc();
      window.addEventListener('load', clampDesc);
    }

    /* ---------- ships-by date ---------- */
    var ship = root.querySelector('[data-lgp-ship]');
    if (ship) {
      var d = addBusinessDays(new Date(), parseInt(root.dataset.handling, 10) || 14);
      ship.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }

    /* ---------- gallery ---------- */
    var slidesBox = root.querySelector('[data-lgp-slides]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lgp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lgp-thumb]'));
    var count = root.querySelector('[data-lgp-count]');
    var hasTones = slides.some(function (s) { return toneOf(s.dataset.src, s.dataset.alt); });
    function visible() { return slides.filter(function (s) { return !s.hidden; }); }
    function activeIndex() {
      var vis = visible(); if (!slidesBox || !vis.length) return 0;
      var i = Math.round(slidesBox.scrollLeft / slidesBox.clientWidth);
      return Math.max(0, Math.min(vis.length - 1, i));
    }
    function syncThumbs() {
      var vis = visible(), i = activeIndex(), cur = vis[i];
      thumbs.forEach(function (t) { t.classList.toggle('is-active', cur && t.dataset.lgpThumb === cur.dataset.lgpSlide); });
      if (count) count.textContent = vis.length > 1 ? (i + 1) + ' / ' + vis.length : '';
    }
    function goTo(i, smooth) {
      var vis = visible(); if (!vis.length) return;
      i = (i + vis.length) % vis.length;
      slidesBox.scrollTo({ left: i * slidesBox.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      setTimeout(syncThumbs, smooth === false ? 0 : 350);
    }
    if (slidesBox) {
      var st; slidesBox.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(syncThumbs, 80); }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var vis = visible(), idx = vis.findIndex(function (s) { return s.dataset.lgpSlide === t.dataset.lgpThumb; });
          if (idx > -1) goTo(idx);
        });
      });
      var prev = root.querySelector('[data-lgp-prev]'), next = root.querySelector('[data-lgp-next]');
      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });
      syncThumbs();
    }
    function filterPhotos(tone) {
      if (!hasTones || !tone) return;
      var any = slides.some(function (s) { return toneOf(s.dataset.src, s.dataset.alt) === tone; });
      slides.forEach(function (s, i) {
        var t = toneOf(s.dataset.src, s.dataset.alt);
        var show = !any || !t || t === tone;
        s.hidden = !show;
        if (thumbs[i]) thumbs[i].hidden = !show;
      });
      goTo(0, false);
    }

    /* lightbox */
    var lb = root.querySelector('[data-lgp-lightbox]'), lbImg = root.querySelector('[data-lgp-lb-img]');
    if (lb && lb.showModal) {
      root.querySelectorAll('[data-lgp-zoom]').forEach(function (b) {
        b.addEventListener('click', function () { lbImg.src = b.dataset.lgpZoom; lbImg.alt = (b.querySelector('img') || {}).alt || ''; lb.showModal(); });
      });
      root.querySelector('[data-lgp-lb-close]').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
    }

    /* ---------- variants ---------- */
    function selected() {
      return opts.map(function (o) { var r = o.querySelector('input:checked'); return r ? r.value : null; });
    }
    function find(values) {
      return product.variants.find(function (v) { return v.options.every(function (ov, i) { return values[i] == null || ov === values[i]; }); });
    }
    function markAvailability(values) {
      opts.forEach(function (o, i) {
        o.querySelectorAll('input').forEach(function (r) {
          var test = values.slice(); test[i] = r.value;
          var v = product.variants.find(function (x) { return x.options.every(function (ov, j) { return ov === test[j]; }); });
          r.classList.toggle('is-off', !v || !v.available);
        });
        var chosen = o.querySelector('[data-lgp-chosen]'), r = o.querySelector('input:checked');
        if (chosen && r) chosen.textContent = nice(r.value);
      });
    }
    function apply(v, push) {
      if (!v) return;
      current = v;
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      var p = money(v.price, fmt);
      nowEl.textContent = p;
      if (barPrice) barPrice.textContent = p;
      if (v.compare_at_price && v.compare_at_price > v.price) { wasEl.textContent = money(v.compare_at_price, fmt); wasEl.hidden = false; } else { wasEl.hidden = true; }
      atc.disabled = !v.available; atcLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (metalCell) metalCell.textContent = nice(v.title);
      if (skuCell) skuCell.textContent = v.sku || '';
      if (push) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      var tone = null;
      opts.forEach(function (o) { if (o.dataset.color === 'true') { var r = o.querySelector('input:checked'); if (r) tone = toneOfValue(r.value) || tone; } });
      if (!tone && toneBox) tone = syncTone(v);
      filterPhotos(tone);
    }
    /* separate Metal color picker (products with only a Metal option): platinum is always white */
    function syncTone(v) {
      var plat = /platinum/i.test((v && v.title) || '');
      var white = toneRadios.find(function (r) { return r.dataset.tone === 'white'; });
      toneRadios.forEach(function (r) {
        var off = plat && r !== white;
        r.disabled = off; r.classList.toggle('is-off', off);
      });
      var cur = toneRadios.find(function (r) { return r.checked; });
      if (plat && white) { white.checked = true; cur = white; }
      if (!cur || cur.disabled) {
        /* default: the colour of the first photo, else the first swatch */
        var first = slides.length ? toneOf(slides[0].dataset.src, slides[0].dataset.alt) : null;
        cur = toneRadios.find(function (r) { return !r.disabled && r.dataset.tone === first; }) || toneRadios.find(function (r) { return !r.disabled; });
        if (cur) cur.checked = true;
      }
      if (white) white.value = plat ? 'White (Platinum)' : 'White Gold';
      if (toneChosen) toneChosen.textContent = toneLabel(cur);
      if (toneNote) toneNote.hidden = !plat;
      return cur ? cur.dataset.tone : null;
    }
    toneRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (toneChosen) toneChosen.textContent = toneLabel(r);
        filterPhotos(r.dataset.tone);
      });
    });

    opts.forEach(function (o, i) {
      o.addEventListener('change', function () {
        var vals = selected();
        var v = find(vals);
        if (!v || !v.available) {
          /* keep the clicked value, choose the closest available combination */
          var mine = vals[i];
          v = product.variants.find(function (x) { return x.available && x.options[i] === mine; }) || product.variants.find(function (x) { return x.options[i] === mine; });
          if (v) opts.forEach(function (oo, j) { var r = Array.prototype.find.call(oo.querySelectorAll('input'), function (x) { return x.value === v.options[j]; }); if (r) r.checked = true; });
        }
        markAvailability(selected());
        apply(v, true);
      });
    });
    var initial = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];
    if (initial && opts.length) {
      opts.forEach(function (o, j) { var r = Array.prototype.find.call(o.querySelectorAll('input'), function (x) { return x.value === initial.options[j]; }); if (r) r.checked = true; });
      markAvailability(selected());
    }
    apply(initial, false);

    /* ---------- engraving ---------- */
    var engBtn = root.querySelector('[data-lgp-engrave-btn]');
    if (engBtn) {
      var box = document.getElementById(engBtn.getAttribute('aria-controls')), inp = box.querySelector('input');
      engBtn.addEventListener('click', function () {
        var open = box.hidden;
        box.hidden = !open; inp.disabled = !open; engBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        engBtn.textContent = open ? '− Remove engraving' : '+ Add free engraving';
        if (open) inp.focus(); else inp.value = '';
      });
    }

    /* ---------- ring size guard ---------- */
    function sizeOk() { return !size || !!size.value; }
    function showErr(on) {
      if (!sizeWrap) return;
      sizeWrap.classList.toggle('has-err', on); err.hidden = !on;
      size.setAttribute('aria-invalid', on ? 'true' : 'false');
    }
    function requireSize() {
      if (sizeOk()) return true;
      showErr(true);
      var y = sizeWrap.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setTimeout(function () { size.focus({ preventScroll: true }); }, 400);
      return false;
    }
    if (size) size.addEventListener('change', function () { if (size.value) showErr(false); if (dyn) dyn.classList.toggle('is-locked', !size.value); });
    var cover = root.querySelector('[data-lgp-dyn-cover]');
    if (cover) cover.addEventListener('click', requireSize);

    /* ---------- add to bag ---------- */
    function updateCount(n) {
      document.querySelectorAll('.ajax-cart-count').forEach(function (el) {
        var s = el.querySelector('span') || el; s.textContent = n; el.classList.toggle('is-zero', !n);
      });
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!requireSize()) return;
      if (!current || !current.available) return;
      atc.classList.add('is-busy');
      msg.hidden = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add to bag');
          return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCount(cart.item_count);
          msg.innerHTML = 'Added to your bag. <a href="/cart">View bag</a> · <a href="/checkout">Checkout</a>';
          msg.hidden = false;
          document.dispatchEvent(new CustomEvent('lgp:added', { detail: { variant: current } }));
        })
        .catch(function (ex) { msg.textContent = ex.message; msg.hidden = false; })
        .finally(function () { atc.classList.remove('is-busy'); });
    });

    /* ---------- sticky bar (phones) ---------- */
    if (bar) {
      var mq = window.matchMedia('(max-width: 989px)');
      var onBar = function () {
        var r = atc.getBoundingClientRect();
        var show = mq.matches && r.bottom < 0;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('lgp-bar-on', show);
      };
      window.addEventListener('scroll', onBar, { passive: true });
      window.addEventListener('resize', onBar);
      onBar();
      barBtn.addEventListener('click', function () {
        if (!requireSize()) return;
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  
    // Metal Guide Drawer / Modal
    var mgOpenBtn = root.querySelector('[data-lgp-metal-guide-open]');
    var mgOverlay = root.querySelector('[data-lgp-metal-guide-overlay]');
    var mgSheet = root.querySelector('[data-lgp-metal-guide-sheet]');
    var mgCloseBtns = root.querySelectorAll('[data-lgp-metal-guide-close]');

    if (mgOpenBtn && mgOverlay && mgSheet) {
      function openMetalGuide() {
        mgOverlay.hidden = false;
        mgSheet.hidden = false;
        mgSheet.offsetHeight; // force reflow
        mgOverlay.classList.add('is-active');
        mgSheet.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }

      function closeMetalGuide() {
        mgOverlay.classList.remove('is-active');
        mgSheet.classList.remove('is-active');
        document.body.style.overflow = '';
        setTimeout(function() {
          if (!mgSheet.classList.contains('is-active')) {
            mgOverlay.hidden = true;
            mgSheet.hidden = true;
          }
        }, 300);
      }

      mgOpenBtn.addEventListener('click', openMetalGuide);
      mgCloseBtns.forEach(function(btn) {
        btn.addEventListener('click', closeMetalGuide);
      });
      mgOverlay.addEventListener('click', closeMetalGuide);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !mgSheet.hidden) {
          closeMetalGuide();
        }
      });
    }

  }function boot() { document.querySelectorAll('.lgp[data-section]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();